<template>
    <Button
        :text="buttonText"
        :title="buttonTitle"
        :buttonClass="buttonClass"
        :size="buttonSize"
        :disabled="buttonDisabled"
        :loading="loading"
        @click="openModal"
        v-if="visible == 'all' && (buttonText != '' || (buttonText == '' && buttonClass != 'default') || (buttonText == '' && buttonSize == 'small'))"
    />

    <teleport to="#modals">
        <transition name="modal-animation">
            <div
                class="modal fixed top-0 left-0 z-50 pt-24 pb-10 px-4 w-screen h-screen bg-black bg-opacity-30 overflow-y-auto"
                v-show="show"
                :id="id"
                @click="modalClick"
            >
                <transition name="modal-animation-inner">
                    <div
                        class="modal-inner inline-block w-1/3 max-w-full relative left-1/2 transform -translate-x-1/2 bg-white py-8 px-6 shadow-md rounded-xl"
                        :class="modalClass"
                    >
                        <div
                            class="absolute top-1.5 right-2.5 text-xl cursor-pointer hover:opacity-75 transition"
                            @click="closeModal"
                        >
                            <i class="fas fa-times"></i>
                        </div>
                        <slot />
                    </div>
                </transition>
            </div>
        </transition>
    </teleport>
</template>

<script>
import Button from '@/Components/Button.vue'

export default {
    components: {
        Button,
    },
    props: {
        id: {
            String,
            default: ''
        },
        buttonText: {
            type: String,
            default: ''
        },
        buttonTitle: {
            type: String,
            default: (props) => props.buttonText
        },
        buttonClass: {
            type: String,
            default: 'primary',//primary, secondary, default, info, alt, danger, success, save, delete, edit, show, ...
        },
        buttonSize: {
            type: String,
            default: 'default',//small
        },
        buttonDisabled: {
            type: Boolean,
            default: false
        },
        modalClass: {
            type: String,
        },
        modalClose: {
            type: Boolean,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        visible: {
            type: String,
            default: "all"
        },
    },
    emits: ['modalOpened', 'modalClosed'],
    data() {
        return {
            show: false
        }
    },
    methods: {
        modalClick(event) {
            if (event.target.getAttribute('data-modal') == 'close') {
                this.closeModal()
            }
        },
        closeModal() {
            this.$emit('modalClosed', this.id)
            this.show = false
        },
        openModal() {
            this.$emit('modalOpened', this.id)
            this.show = true
        }
    },
}
</script>

<style scoped>
.modal-inner {
    min-width: min-content;
}

.modal-animation-enter-active,
.modal-animation-leave-active {
    transition: opacity 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}

.modal-animation-enter-from,
.modal-animation-leave-to {
    opacity: 0;
}

.modal-animation-inner-enter-active {
    transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02) 0.15s;
}
.modal-animation-inner-leave-active {
    transition: all 0.3s cubic-bezier(0.52, 0.02, 0.19, 1.02);
}

.modal-animation-inner-enter-from {
    opacity: 0;
    transform: scale(0.8);
}

.modal-animation-inner-leave-to {
    transform: scale(0.8);
}
</style>
